import { NoAccessibleWorkspacesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/no_accessible_workspaces/$')({
  component: NoAccessibleWorkspacesRoute,
});
